import { ButtonGroup, Card, Heading } from '@shopify/polaris';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { SpaceBetweenRowContainer } from '../container/common';
import { StyledElement } from '../types';

const Container = styled.div`
  margin-top: ${({ theme }) => theme.space.default};

  h2 {
    margin-right: ${({ theme }) => theme.space.default};
  }

  .Polaris-Heading {
    font-size: 16px;
  }

  .Polaris-Button {
    border-radius: 4px;
  }

  .Polaris-ButtonGroup__Item {
    margin-left: 0;
    margin-right: 0.8rem;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export type FilterBarProps = {
  filters: any[];
  title?: string;
} & StyledElement;

const FilterBar: FunctionComponent<FilterBarProps> = ({
  className,
  filters,
  title,
}) => {
  return (
    <Container className={className}>
      <Card sectioned>
        <SpaceBetweenRowContainer>
          {title && <Heading>{title}</Heading>}
          <ButtonGroup>{filters.map((filter) => filter)}</ButtonGroup>
        </SpaceBetweenRowContainer>
      </Card>
    </Container>
  );
};

export default FilterBar;
